export const GROUP_IS_FULL = 'GROUP_IS_FULL'
